import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isExternalUrl',
  standalone: true,
})
export class IsExternalUrlPipe implements PipeTransform {
  transform(url?: string): boolean {
    return !!url && /^https?:\/\//.test(url);
  }
}
